<template>
    <!-- <div class="border border-red-500"> -->
        <base-dblclick-textarea
            model-type="contact"
            :model-id="clientContact.id"
            field-name="personal_notes"
            :field-value="clientContact.personal_notes"
            @refetch="fetchNewClients"
        >
            <slot name="icon"></slot>
        </base-dblclick-textarea>
    <!-- </div> -->
</template>


<script setup>
import { defineProps, defineEmits } from "vue";

  const props = defineProps({
      clientContact: Object
  })

  const emit = defineEmits(['refetch-clients'])

  function fetchNewClients() {
      emit('refetch-clients')
  }
</script>